import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import styles from "./Header.module.css";
import logo from "../../assets/stoneforex-logo.png";

function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const { user, logout } = useAuth();
  const isHome = location.pathname === "/";
  
  // ✅ Determine which pages should show user controls
  const isDashboardPage = location.pathname.startsWith('/dashboard');
  const isAdminPage = location.pathname.startsWith('/admin');
  const isUserArea = isDashboardPage || isAdminPage;

  // Add scroll detection for enhanced styling
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Scroll to section function with correct mapping
  const scrollToSection = (id) => {
    if (!isHome) {
      window.location.href = `/#${id}`;
      return;
    }
    const el = document.getElementById(id);
    if (el) {
      const HEADER_HEIGHT = 70;
      const pos = el.offsetTop - HEADER_HEIGHT;
      window.scrollTo({ top: pos, behavior: "smooth" });
    }
  };

  return (
    <header className={`${styles.header} ${isScrolled ? styles.scrolled : ''}`}>
      <div className={styles.container}>
        {/* Logo - Far Left */}
        <Link to="/" className={styles.brand}>
          <img src={logo} alt="StoneForex" className={styles.logo} />
        </Link>

        {/* Navigation - Center (Only show on public pages) */}
        {!isUserArea && (
          <nav className={styles.navigation}>
            <button className={styles.navBtn} onClick={() => scrollToSection('markets')}>
              Markets
            </button>
            <button className={styles.navBtn} onClick={() => scrollToSection('accounts')}>
              Accounts
            </button>
            <button className={styles.navBtn} onClick={() => scrollToSection('services')}>
              Services
            </button>
            <button className={styles.navBtn} onClick={() => scrollToSection('news')}>
              News
            </button>
            <button className={styles.navBtn} onClick={() => scrollToSection('education')}>
              Education
            </button>
            <button className={styles.navBtn} onClick={() => scrollToSection('about')}>
              About Us
            </button>
          </nav>
        )}

        {/* User Area Navigation (Dashboard/Admin pages only) */}
        {isUserArea && user && (
          <nav className={styles.navigation}>
            <Link to="/" className={styles.navBtn}>
              🏠 Home
            </Link>
            {user.role === 'user' && isDashboardPage && (
              <>
                <Link to="/dashboard" className={styles.navBtn}>
                  📊 Dashboard
                </Link>
                <Link to="/dashboard/demo-accounts" className={styles.navBtn}>
                  Demo Accounts
                </Link>
                <Link to="/dashboard/markets" className={styles.navBtn}>
                  Markets
                </Link>
                <Link to="/dashboard/portfolio" className={styles.navBtn}>
                  Portfolio
                </Link>
              </>
            )}
            {user.role === 'admin' && isAdminPage && (
              <Link to="/admin" className={styles.navBtn}>
                ⚡ Admin Panel
              </Link>
            )}
          </nav>
        )}

        {/* Buttons - Far Right */}
        <div className={styles.actions}>
          {isUserArea ? (
            // ✅ DASHBOARD/ADMIN PAGES: Show logout only
            <button 
              onClick={logout} 
              className={styles.logoutBtn}
              title="Logout and return to homepage"
            >
              🚪 Logout ({user?.firstName || 'User'})
            </button>
          ) : (
            // ✅ HOMEPAGE & PUBLIC PAGES: ALWAYS show login/register (even if logged in)
            <>
              <Link to="/login" className={styles.loginBtn}>
                Log in
              </Link>
              <Link to="/create-account" className={styles.startTradingBtn}>
                Open an Account
              </Link>
            </>
          )}
        </div>
      </div>
    </header>
  );
}

export default Header;
